// extracted by mini-css-extract-plugin
module.exports = {"cardBtn":"index_cardBtn_2Qptl"};